import get from '../../../common/services/api/get';

/**
 * return all products metadata
 * @returns [{area, suite, product, category, label, type}]
 */
export default function getProducts(hierarchyType) {
    const queryParamString = hierarchyType ? `?hierarchy_type=${hierarchyType}` : '';
    return get(`/api/v1/products${queryParamString}`);
}
